import ClearIcon from "@mui/icons-material/Clear"
import { Grid, IconButton, TextField } from "@mui/material"
import { CalendarPickerView, DatePicker } from "@mui/x-date-pickers"
import React, { useMemo } from "react"
import { customPalette } from "../../../../theme"

interface IProps {
  label: string
  value: Date | undefined
  views?: readonly CalendarPickerView[] | undefined
  hideButton?: boolean
  borderRadius?: number
  hideBorder?: boolean
  backgroundColor?: string
  errorText?: string
  helperText?: string
  disablePast?: boolean

  handleChange(date: Date | undefined): void
}

export function DateInput({
  label,
  value,
  views,
  hideButton,
  borderRadius,
  hideBorder,
  backgroundColor,
  errorText,
  helperText,
  disablePast = true,
  handleChange,
}: Readonly<IProps>): React.JSX.Element {
  function changeDate(date: Date | null): void {
    if (date === null) {
      return
    }
    handleChange(date)
  }

  function emptyDate(): void {
    handleChange(undefined)
  }

  const isError = useMemo(() => Boolean(errorText), [errorText])

  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={hideButton ? 12 : 11}>
        <DatePicker
          label={label}
          onChange={changeDate}
          views={views}
          disablePast={disablePast}
          value={value || null}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              error={isError}
              helperText={isError ? errorText : helperText}
              sx={{
                mt: 2,
                mb: 2,
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: borderRadius ?? 0,
                  overflow: "hidden",
                  backgroundColor: backgroundColor ?? customPalette.white,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: hideBorder ? "none" : undefined,
                    borderRadius: borderRadius ?? 0,
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: hideBorder ? "none" : undefined,
                    borderRadius: borderRadius ?? 0,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: hideBorder ? "none" : undefined,
                    borderRadius: borderRadius ?? 0,
                  },
                },
              }}
            />
          )}
        />
      </Grid>
      {!hideButton && (
        <Grid item xs={1} container justifyContent="center" alignItems="center">
          <IconButton onClick={emptyDate}>
            <ClearIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  )
}
